import { render, staticRenderFns } from "./RegistrationCompleted.vue?vue&type=template&id=917a688c&scoped=true&"
import script from "./RegistrationCompleted.vue?vue&type=script&lang=js&"
export * from "./RegistrationCompleted.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationCompleted.vue?vue&type=style&index=0&id=917a688c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "917a688c",
  null
  
)

export default component.exports